/**
 * Key/byte formatting shared across the app. Previously lived under
 * the retired chain-specific app helpers; it was never chain-specific.
 */
import { deriveViewingKey } from "../joinsplit/keys";

export function formatMpkHex(mpk: bigint): string {
  return `0x${mpk.toString(16).padStart(64, "0")}`;
}

export function bytesToHex(bytes: Uint8Array): string {
  return Buffer.from(bytes).toString("hex");
}

export function formatViewingKeyHex(spendingKey: Uint8Array): string {
  return bytesToHex(deriveViewingKey(spendingKey));
}

function toArrayBuffer(bytes: Uint8Array): ArrayBuffer {
  return bytes.buffer.slice(
    bytes.byteOffset,
    bytes.byteOffset + bytes.byteLength,
  ) as ArrayBuffer;
}

export async function hashMpkHex(mpkHex: string): Promise<string> {
  const mpkBytes = new TextEncoder().encode(mpkHex);
  const hashBuffer = await crypto.subtle.digest(
    "SHA-256",
    toArrayBuffer(mpkBytes),
  );
  return Buffer.from(new Uint8Array(hashBuffer)).toString("hex");
}
